import React, { useEffect, useState } from 'react';
import '../styles/styles.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

import { storage } from '../storage';
import { getUserById } from '../firebase';

const Gracias = ({ history }) => {
  const [user, setUser] = useState({});

  useEffect(() => {
    const userID = storage.getItem('userID');
    if (userID) {
      getUserById(userID)
        .then(u => {
          setUser(u)
        })
        .catch(e => console.log(e));
    } else {
      history.push('/');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const salir = () => {
    storage.removeItem('userID');
  };
  return (
    <div>
      <Navbar />
      <div className="thanks">
        <div className="thanksTitle">
          <p>
            <strong>¡Gracias por Participar!</strong>
          </p>
          <br />
        </div>
        <div className="thanksResults">
          <p>
            Nombre: <strong>{user.name}</strong>
          </p>
          <p>
            Email: <strong>{user.email}</strong>
          </p>
          <p>
            Aciertos:{' '}
            <strong>
              {user.rights} de {user.possible}
            </strong>
          </p>

          <br />

          <button onClick={salir} className="thanksResultsBotton">
            <a href="https://mexicocity.shopdutyfree.com/es/">
              Ir a Duty Free Ciudad de México
            </a>
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Gracias;
